import React, {useState, useEffect, useContext} from 'react';
import {Context} from '../../context';

export default function Pagination(props) {
  const {localeText} = useContext(Context);
  const [page, setPage] = useState(1);
  const [inputPage, setInputPage] = useState(page);
  const {list, setPaginatedList, itemsPerPage, runOnPageJump, className} =
    props;
  const lastPageNum = Math.ceil(list.length / itemsPerPage);

  const updatePage = () => {
    setInputPage(page);
    if (runOnPageJump) runOnPageJump();
    const startingIndex = (page - 1) * itemsPerPage;
    const endingIndex = startingIndex + itemsPerPage;
    setPaginatedList(list.slice(startingIndex, endingIndex));
  };

  // reset Pagination back to page 1 if list updates
  useEffect(() => {
    setPage(1);
    updatePage(); // incase page is already 1, we'll need to trigger page reset here
  }, [list]);

  // when page changes, update all Panination displays
  useEffect(() => {
    updatePage();
  }, [page, list, itemsPerPage, setPaginatedList]);

  const handleInputEntry = e => {
    const pageNum = Number(inputPage);
    if (e.key === 'Enter') {
      if (pageNum < 1) {
        setInputPage(1);
        setPage(1);
      } else if (pageNum > lastPageNum) {
        setPage(lastPageNum);
        setInputPage(lastPageNum);
      } else {
        setPage(pageNum);
        setInputPage(pageNum);
      }
    }
  };

  const prevPage = () => {
    setPage(prev => {
      const pageNum = prev - 1;
      if (pageNum <= 1) {
        return 1;
      }
      return pageNum;
    });
  };

  const nextPage = () => {
    setPage(prev => {
      const pageNum = prev + 1;
      if (pageNum > lastPageNum) {
        return lastPageNum;
      }
      return pageNum;
    });
  };

  const firstPage = () => {
    setPage(1);
  };

  const lastPage = () => {
    setPage(lastPageNum);
  };

  const btnClassName =
    'border hover:border-black p-2 transition ease-in-out cursor-pointer hover:z-10';

  if (list?.length === 0) {
    return;
  }

  return (
    <div
      title='pagination controls'
      className={`flex flex-wrap justify-center sm:justify-between items-center bg-white p-2 ${className}`}
    >
      <div className='p-2 font-bold'>
        {localeText('rw_title_total_items', 'Total Items')}: {list.length}
      </div>
      <div className='flex'>
        <i
          title='first page'
          onClick={firstPage}
          className={`fa-sharp fa-solid fa-backward-fast ${btnClassName}`}
        />
        <i
          title='previous page'
          onClick={prevPage}
          className={`fa-sharp fa-solid fa-backward-step -ml-[1px] ${btnClassName}`}
        />
        <input
          title='pagination-input'
          className='w-10 text-right'
          type='text'
          min='1'
          value={inputPage}
          onChange={e => setInputPage(e.target.value)}
          onKeyDown={handleInputEntry}
        />
        <div className='flex items-center pr-4 gap-3'>
          <div>&nbsp;&nbsp;&nbsp;{localeText('rw_frag_of', 'of')}</div>
          <div>{lastPageNum}</div>
        </div>
        <i
          title='next page'
          onClick={nextPage}
          className={`fa-sharp fa-solid fa-forward-step -mr-[1px] ${btnClassName}`}
        />
        <i
          title='last page'
          onClick={lastPage}
          className={`fa-sharp fa-solid fa-forward-fast ${btnClassName}`}
        />
      </div>
    </div>
  );
}
